// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QZrf","importantInfo":"styles_importantInfo__1eGzt"};